import React from 'react';
import { observer, inject } from 'mobx-react';
import { withTranslation } from 'react-i18next';
import * as Icons from '@material-ui/icons';
import {
  withStyles,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  IconButton,
  Collapse,
  Paper,
  Tooltip,
} from '@material-ui/core';
import tinycolor from 'tinycolor2';
import moment from 'moment';
import * as Colors from '../../../../themes/summaryReportColor';
import { Typography } from 'antd';

class ContentRow extends React.Component {
  // getAlertsData(alerts) {
  //   const { t } = this.props;
  //   const alertInfo = [];
  //   Object.entries(alerts).map(([key, value]) => {
  //     let backgroundColor = '#ffffff';
  //     let color = '#ffffff';
  //     let name = '';
  //     switch (+key) {
  //       case 501:
  //         color = Colors.COLOR_ALERT_GETUP;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_GETUP).lighten(30).toHexString();
  //         name = `${t('get_up')}: ${value}`;
  //         break;
  //       case 502:
  //         color = Colors.COLOR_ALERT_MOVEMENT;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_MOVEMENT).lighten(12).toHexString();
  //         name = `${t('movement')}: ${value}`;
  //         break;
  //       case 503:
  //         color = Colors.COLOR_ALERT_BATTERY_LOW;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_BATTERY_LOW).lighten(30).toHexString();
  //         name = `${t('low_battery')}: ${value}`;
  //         break;
  //       case 506:
  //         color = Colors.COLOR_ALERT_NOT_TURN_FOR;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_NOT_TURN_FOR).lighten(60).toHexString();
  //         name = `${t('alert_not_turn')}: ${value}`;
  //         break;
  //       case 507:
  //         color = Colors.COLOR_ALERT_NO_MOVEMENT_FOR;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_NO_MOVEMENT_FOR).lighten(60).toHexString();
  //         name = `${t('alert_no_movement')}: ${value}`;
  //         break;
  //       case 508:
  //         color = Colors.COLOR_ALERT_FALL;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_FALL).lighten(50).toHexString();
  //         name = `${t('alert_fall')}: ${value}`;
  //         break;
  //       case 509:
  //         color = Colors.COLOR_ALERT_OUT_OF_AREA;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_OUT_OF_AREA).lighten(40).toHexString();
  //         name = `${t('alert_exit')}: ${value}`;
  //         break;
  //       case 510:
  //         color = Colors.COLOR_ALERT_INTO_AREA;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_INTO_AREA).lighten(30).toHexString();
  //         name = `${t('alert_near')}: ${value}`;
  //         break;
  //       case 511:
  //         color = Colors.COLOR_ALERT_WALKING_AT_NIGHT;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_WALKING_AT_NIGHT).lighten(30).toHexString();
  //         name = `${t('alert_walking')}: ${value}`;
  //         break;
  //       case 514:
  //         color = Colors.COLOR_ALERT_EMERGENCY_ALARM;
  //         backgroundColor = tinycolor(Colors.COLOR_ALERT_EMERGENCY_ALARM).lighten(30).toHexString();
  //         name = `${t('alert_emergency_alarm')}: ${value}`;
  //         break;
  //       default:
  //         break;
  //     }

  //     alertInfo.push({ name, color, backgroundColor });
  //   });

  //   return (
  //     <div>
  //       {alertInfo.map((a, i) => (
  //         <label
  //           key={i}
  //           style={{
  //             position: 'relative',
  //             color: a.color,
  //             backgroundColor: a.backgroundColor,
  //             padding: '2px 11px',
  //             borderRadius: '14px',
  //             overFlow: 'hidden',
  //             whiteSpace: 'nowrap',
  //             fontSize: 12,
  //             margin: 2,
  //           }}
  //         >
  //           {a.name}
  //         </label>
  //       ))}
  //     </div>
  //   );
  // }

  getAlertsData(alerts) {
    const { t } = this.props;
  
    // Define the alert types with their colors and lightened background colors
    const alertTypes = {
      501: { color: Colors.COLOR_ALERT_GETUP, name: 'get_up' },
      502: { color: Colors.COLOR_ALERT_MOVEMENT, name: 'movement' },
      503: { color: Colors.COLOR_ALERT_BATTERY_LOW, name: 'low_battery' },
      506: { color: Colors.COLOR_ALERT_NOT_TURN_FOR, name: 'alert_not_turn' },
      507: { color: Colors.COLOR_ALERT_NO_MOVEMENT_FOR, name: 'alert_no_movement' },
      508: { color: Colors.COLOR_ALERT_FALL, name: 'alert_fall' },
      509: { color: Colors.COLOR_ALERT_OUT_OF_AREA, name: 'alert_exit' },
      510: { color: Colors.COLOR_ALERT_INTO_AREA, name: 'alert_near' },
      511: { color: Colors.COLOR_ALERT_WALKING_AT_NIGHT, name: 'alert_walking' },
      514: { color: Colors.COLOR_ALERT_EMERGENCY_ALARM, name: 'alert_emergency_alarm' },
    };
  
    // Map alert data to displayable info
    const alertInfo = Object.entries(alerts).map(([key, value]) => {
      const alert = alertTypes[+key] || {};
      const backgroundColor = alert.color ? tinycolor(alert.color).lighten(30).toHexString() : '#ffffff';
      return {
        name: `${t(alert.name || 'unknown')}: ${value}`,
        color: alert.color || '#ffffff',
        backgroundColor,
      };
    });
  
    // Render the alert info
    return (
      <div>
        {alertInfo.map((a, i) => (
          <label
            key={i}
            style={{
              position: 'relative',
              color: a.color,
              backgroundColor: a.backgroundColor,
              padding: '2px 11px',
              borderRadius: '14px',
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              fontSize: 12,
              margin: 2,
            }}
          >
            {a.name}
          </label>
        ))}
      </div>
    );
  }
  

  // getCountAlerts(alerts) {
  //   let countAlerts = 0;
  //   Object.keys(alerts).length > 0 &&
  //     Object.entries(alerts).map(([key, value]) => {
  //       countAlerts = countAlerts + value;
  //     });
  //   return countAlerts;
  // }

  getCountAlerts(alerts) {
    return Object.values(alerts).reduce((total, value) => total + value, 0);
  }
  

  render() {
    const { t, classes, data, index } = this.props;
    return (
      <>
        <TableRow key={index}>
          <TableCell component='th' scope='row' className={classes.ContentRowBody}>
            {data.name}
          </TableCell>
          <TableCell component='th' scope='row' className={classes.ContentRowBody}>
            {data.assignedDevices.length}
          </TableCell>
          <TableCell component='th' scope='row' className={classes.ContentRowBody}>
            {data.totalCountMsg}
          </TableCell>
          <TableCell component='th' scope='row' className={classes.ContentRowBody}>
            {data.totalCountDay}/{data.activeAllDays ? data.activeAllDays : 0}
          </TableCell>
          <TableCell component='th' scope='row' className={classes.ContentRowBody}>
            {this.getCountAlerts(data.alerts)}
          </TableCell>
          <TableCell align='right' className={classes.ContentRowBody}>
            <IconButton aria-label='expand row' size='small' onClick={() => this.props.handleToggle(index)}>
              {data.toggle ? <Icons.ExpandLess /> : <Icons.ExpandMore />}
            </IconButton>
          </TableCell>
        </TableRow>

        <TableRow style={{ display: data.toggle ? 'table-row' : 'none' }}>
          <TableCell colSpan={12} style={{ padding: 0 }}>
            <Collapse
              in={data.toggle}
              timeout='auto'
              unmountOnExit
              style={{
                backgroundColor: '#E6F4F3',
                padding: '4px 16px',
                borderBottom: '1px solid #B8CFC3',
              }}
            >
              <Paper className={classes.paperTable}>
                <Table>
                  <TableHead>
                    <TableRow style={{ border: 'none', height: 40 }}>
                      <CustomTableCell className={classes.tableWidth}>{t('device')}</CustomTableCell>
                      <CustomTableCell className={classes.tableWidth}>{t('device_type')}</CustomTableCell>
                      <CustomTableCell className={classes.tableWidth}>{t('status')}</CustomTableCell>
                      <CustomTableCell className={classes.tableWidth50}>{t('messages')}</CustomTableCell>
                      <CustomTableCell className={classes.tableWidth50}>{t('active_days')}</CustomTableCell>
                      <CustomTableCell>{t('alerts')}</CustomTableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {data.assignedDevices.map((device, i) => (
                      <TableRow key={i}>
                        <CustomTableCell component='th' scope='row' className={classes.tableWidth}>
                          <div className={device.unassigned ? classes.textUnassigned : ''}>{device.serialNumber}</div>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row' className={classes.tableWidth}>
                          <label
                            className={`badge ${
                              device.deviceCategory === 'EMERGENCY_BUTTON'
                                ? 'badge-wizard-error'
                                : device.deviceCategory === 'AIRNODE'
                                  ? 'badge-wizard-info'
                                  : 'badge-wizard-indigo'
                            }`}
                          >
                            <span className='dot' />
                            {device.deviceCategory === 'EMERGENCY_BUTTON'
                              ? 'Emergency Button'
                              : device.deviceCategory === 'AIRNODE'
                                ? 'AiR'
                                : 'Beacon Tag'}
                          </label>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row' className={classes.tableWidth}>
                          <Tooltip
                            style={{ cursor: 'pointer' }}
                            title={
                              <div>
                                <Typography className={classes.tootipTitle}>
                                  {t('assigned_date')} :{' '}
                                  {device.assigned ? moment(device.assigned).format('DD/MM/YYYY HH:mm') : ''}
                                </Typography>
                                {device.unassigned && (
                                  <Typography className={classes.tootipTitle}>
                                    {t('unassigned_date')}: {moment(device.unassigned).format('DD/MM/YYYY HH:mm')}
                                  </Typography>
                                )}
                              </div>
                            }
                          >
                            {device.unassigned ? (
                              <div className={classes.textUnassigned}>{t('unassigned')}</div>
                            ) : (
                              <div>{t('assigned')}</div>
                            )}
                          </Tooltip>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row' className={classes.tableWidth50}>
                          <div className={device.unassigned ? classes.textUnassigned : ''}>{device.countMsg}</div>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row' className={classes.tableWidth50}>
                          <Tooltip
                            title={
                              <div>
                                {device.startDateOfUseDeviceInPeriod === device.endDateOfUseDeviceInPeriod ? (
                                  <Typography className={classes.tootipTitle}>
                                    {t('date_range')}:{' '}
                                    {moment(device.startDateOfUseDeviceInPeriod).format('DD/MM/YYYY')}
                                  </Typography>
                                ) : (
                                  <Typography className={classes.tootipTitle}>
                                    {t('date_range')}:{' '}
                                    {moment(device.startDateOfUseDeviceInPeriod).format('DD/MM/YYYY')} -{' '}
                                    {moment(device.endDateOfUseDeviceInPeriod).format('DD/MM/YYYY')}
                                  </Typography>
                                )}
                              </div>
                            }
                          >
                            <div
                              className={device.unassigned ? classes.textUnassigned : ''}
                              style={{ cursor: 'pointer' }}
                            >
                              {device.countDate}/
                              {-Math.ceil(
                                (new Date(device.startDateOfUseDeviceInPeriod) -
                                  new Date(device.endDateOfUseDeviceInPeriod)) /
                                  (1000 * 60 * 60 * 24),
                              ) + 1}
                            </div>
                          </Tooltip>
                        </CustomTableCell>
                        <CustomTableCell component='th' scope='row'>
                          {Object.keys(device.alerts).length > 0 && this.getAlertsData(device.alerts)}
                        </CustomTableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Paper>
            </Collapse>
          </TableCell>
        </TableRow>
      </>
    );
  }
}

const CustomTableCell = withStyles((theme) => ({
  head: {
    color: theme.palette.text.secondary,
    border: 'none',
    fontWeight: 500,
    fontSize: 14,
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    // [theme.breakpoints.down("md")]: {
    //   maxWidth: "200px",
    // },
  },
  body: {
    color: theme.palette.primary.main,
    fontSize: 16,
    borderTop: '1px solid #B8CFC3',
    borderBottom: 'none',
    // fontWeight: 500
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    // whiteSpace: "nowrap",
    // [theme.breakpoints.down("sm")]: {
    //   width: "200px",
    // },
  },
}))(TableCell);

const styles = (theme) => ({
  paperTable: {
    boxShadow: 'none',
    border: '1px solid #B8CFC3',
    borderRadius: '2px',
    position: 'relative',
    overflowX: 'auto',
    // borderRadius: "8px",
  },
  ContentRowBody: {
    color: theme.palette.text.header,
    fontSize: 16,
    borderBottom: '1px solid #B8CFC3',
    borderTop: 'none',
    padding: 4,
    // overflow: "hidden",
    // textOverflow: "ellipsis",
    // whiteSpace: "nowrap",
  },
  tootipTitle: {
    color: theme.palette.secondary.contrastText,
    fontSize: 14,
    margin: 4,
  },
  tableWidth: {
    width: 220,
  },
  tableWidth50: {
    width: 150,
  },
  textUnassigned: {
    color: '#767676',
    fontWeight: 300,
  },
});
export const page = inject()(observer(ContentRow));
export const translation = withTranslation()(page);
export default withStyles(styles, { withTheme: true })(translation);
